import { Box, Typography } from '@mui/material'
import React from 'react'

type PlacehodlerProps = {
  title: string,
}

export const DatagridPlaceholder = (props: PlacehodlerProps): JSX.Element => {
  return (
  <Box display='flex' justifyContent='center' pt={5} alignItems='center'>
    <Typography>{props.title}</Typography>
  </Box>
  )
}